import { Select, Box } from '@shopify/polaris';
import { MediaAssetType } from '@/types/media';
import { startTransition } from 'react';

type AssetType = Exclude<MediaAssetType, MediaAssetType.audio>;

type AssetTypeSelectorProps = {
  assetType: AssetType | undefined;
  setAssetType: (assetType: AssetType | undefined) => void;
  includeAllOption?: boolean;
};

const AssetTypeSelector = ({ assetType, setAssetType, includeAllOption = true }: AssetTypeSelectorProps) => {
  const options = [
    ...(includeAllOption ? [{ label: 'All', value: 'all' }] : []),
    { label: 'Videos', value: MediaAssetType.video },
    { label: 'Images', value: MediaAssetType.image },
  ];

  const handleChange = (value: string) => {
    startTransition(() => {
      if (value === 'all') {
        setAssetType(undefined);
      } else {
        setAssetType(value as AssetType);
      }
    });
  };

  return (
    <Box width="250px">
      <Select
        label="Asset Type"
        options={options}
        value={assetType === undefined ? 'all' : assetType}
        onChange={handleChange}
      />
    </Box>
  );
};

export default AssetTypeSelector;
